import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import './ErrorLayout.css';

const ErrorLayout = ({ code, title, message, icon, color }) => {
  const navigate = useNavigate();

  return (
    <div className="error-layout-container">
      <div className="error-layout-card">
        <i className={`${icon} error-layout-icon`} style={{ color: color }}></i>
        <h1 className="error-layout-code" style={{ color: color }}>{code}</h1>
        <h2 className="error-layout-title">{title}</h2>
        <p className="error-layout-message">{message}</p>
        
        <div className="error-layout-actions flex gap-3 justify-content-center mt-4">
          <Link to="/">
            <Button label="Go Home" icon="pi pi-home" className="p-button-primary p-button-rounded" />
          </Link>
          <Button 
            label="Go Back" 
            icon="pi pi-arrow-left" 
            className="p-button-outlined p-button-secondary p-button-rounded" 
            onClick={() => navigate(-1)} 
          />
        </div>
      </div>
    </div>
  );
};

export default ErrorLayout;